import React, { useEffect } from "react";
import {Link, useSearchParams} from "react-router-dom";
import { Container, Box, Card, Heading, Text, Flex } from "@radix-ui/themes";
import { motion } from "framer-motion";
import { API_BASE_URL } from "../api/config";

function ThankYouPage() {
    useEffect(function () {
        // necháme košík už prázdny (clearCart sa volal pri odoslaní)
        // voliteľne: vyčistiť aj pomocné dáta checkoutu
        localStorage.removeItem("checkout_v1");
        localStorage.removeItem("customer_v1");
    }, []);

    var [params] = useSearchParams();
    var orderId = params.get("orderId");

    var hasInvoice = orderId != null && orderId !== "";

    return (
        <Box p="4">
            <Container size="3">
                <Card>
                    <Box p="5" className="text-center">
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ type: "spring", stiffness: 220, damping: 18 }}
                            className="text-success mb-3"
                            style={{ fontSize: 72, lineHeight: 1 }}
                        >
                            <i className="bi bi-check-circle-fill"></i>
                        </motion.div>

                        <Heading size="7" mb="2">Ďakujeme za objednávku!</Heading>
                        <Text color="gray" size="3">
                            Je nám to veľmi ľúto, ale žiadna objednávka vám nepríde, pretože systém ešte nie je hotový.
                            {/*Vašu objednávku sme prijali. Čoskoro sa vám ozveme s potvrdením a detailami doručenia.*/}
                        </Text>

                        {hasInvoice && (
                            <div className="small text-muted mt-3">Číslo objednávky: {orderId}</div>
                        )}
                        {hasInvoice && (
                        <Flex justify="center" gap="3" mt="5" wrap="wrap">
                            <a href={`${API_BASE_URL}/api/orders/${orderId}/invoice.pdf`}
                                  className="btn btn-outline-success rounded-pill">
                                <span className="bi-download"> Vytlačiť faktúru</span>
                            </a>
                        </Flex>
                        )}
                        <Flex justify="center" gap="3" mt="5" wrap="wrap">
                            <Link to="/ponuka" className="btn btn-brown">Pokračovať v nákupe</Link>
                            <Link to="/" className="btn btn-outline-secondary rounded-pill">Domov</Link>
                        </Flex>
                    </Box>
                </Card>
            </Container>
        </Box>
    );
}

export default ThankYouPage;
